import Page from 'src/apipages/common-formats/index';

export default Page;
